<template>
  <div :class="`zip-selector ${this.showError ? 'error-border' : ''}`">
    <vue-autosuggest
      :suggestions="filteredSuggestions"
      v-model="query"
      :input-props="{
        type: 'search',
        id: 'autosuggest__input',
        placeholder: 'Irányítószám kiválasztása',
        disabled
      }"
      @selected="selectHandler"
      ref="autosuggestRef"
    >
      <template slot-scope="{ suggestion }">
        <span class="my-suggestion-item"> {{ suggestion.item.name }} </span>
      </template>
    </vue-autosuggest>
    <p v-show="this.showError" class="error-message">
      Válassza ki az irányítószámot
    </p>
  </div>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'
import zipCodes from './zipCodes'

export default {
  data: function() {
    return {
      suggestions: zipCodes,
      query: ''
    }
  },
  props: {
    disabled: { type: Boolean },
    alreadySelected: { type: String },
    showError: { type: Boolean }
  },
  components: {
    VueAutosuggest
  },
  computed: {
    filteredSuggestions() {
      return [
        {
          data: this.suggestions.filter(item => {
            return (
              item.name.toLowerCase().indexOf(this.query.toLowerCase()) > -1 ||
              item.zip.toLowerCase().indexOf(this.query.toLowerCase()) > -1
            )
          })
        }
      ]
    }
  },
  methods: {
    selectHandler(item) {
      if (item) {
        this.$emit('selected-zipCode', item.item.zip.toString())
      }
    }
  },
  watch: {
    disabled() {
      if (this.disabled) {
        this.$refs.autosuggestRef.internalValue = ''
      }
    }
  },
  mounted() {
    if (this.alreadySelected !== '') {
      const zipFound = this.suggestions.find(x => x.zip == this.alreadySelected)
      this.$refs.autosuggestRef.internalValue = zipFound.name
      this.$refs.autosuggestRef.searchInputOriginal = zipFound.name
      this.$refs.autosuggestRef.didSelectFromOptions = true
    }
  }
}
</script>

<style>
.zip-selector .autosuggest__results {
  overflow: auto;
}

.zip-selector #autosuggest__input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 2px solid #b2bec3;
  max-height: 50px;
  border-radius: 4px;
  font-size: 16px;
  color: black !important;
}

.zip-selector #autosuggest__input.autosuggest__input--open {
  border: 1px solid #00903c;
}

.error-border #autosuggest__input {
  border: 2px solid #ba3b46 !important;
}
.error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 12px;
}

@media all and (max-width: 993px) {
  .autosuggest__results-item {
    font-size: 12px;
  }
}
</style>
